import type { FormDefinition } from '@/core/templates/types'
import { massnahmeDetailsVergabeForm } from './templates'

export const ORG_SETTINGS_TABS: readonly string[] = ['organisation', 'coaches', 'massnahmen']

export const MASSNAHME_FORM: FormDefinition = massnahmeDetailsVergabeForm

export const HAS_MODULES = false as const

export const HAS_ECN_SETTINGS = false
